import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  TextField,
  Typography,
} from '@mui/material'
import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { usersProvider } from '../providers';
import { useNavigate } from 'react-router-dom';
import { useNotify } from 'react-admin';

const Profile = () => {
  const [cognitoUser, setCognitoUser] = useState({});
  const [username, setUsername] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const notify = useNotify();

  useEffect(() => {
    const getUserInfo = async () => {
      setIsLoading(true);
      const user = await Auth.currentAuthenticatedUser();
      const userData = await usersProvider("GET", "/getUser", { username: user.getUsername() });
      setCognitoUser(user.attributes);
      setUsername(user.attributes.email);
      setDisplayName(userData.UserAttributes.find(attr => attr.Name === "name")?.Value);
      setIsLoading(false);
    };
    getUserInfo();
  }, []);

  const userUpdateHandle = () => {
    setIsLoading(true);
    usersProvider("GET", "/listGroupsForUser", { username: cognitoUser.sub})
      .then((res) => {
        const { Groups } = res;
        usersProvider("PUT", "/updateUser", {
          userid: cognitoUser.sub,
          username: displayName,
          email: username,
          groupname: Groups.map((sr) => sr.GroupName),
        })
        .then((res) => {
          notify('User updated successfully', { type: 'success' });
          window.location.reload();
        })
        .catch(err => {
          console.error('Error updating User:', err);
          notify('Error updating User', { type: 'error' });
        })
        .finally(() => {
          setIsLoading(false);
        });
      })
      .catch((err) => {
        console.error('Error updating User:', err);
        notify('Error updating User', { type: 'error' });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <Card variant='elevation' sx={{ maxWidth: '65%' }}>
      <CardHeader title='Account Settings' sx={{ borderBottom: '1px solid grey' }} />
      <CardContent>
        <Box pb={10} pt={2}>
          <Box display='flex' flexDirection='row' justifyContent='flex-start' alignItems='center'>
            <Typography minWidth={120}>Display Name</Typography>
            <TextField
              label=""
              variant="standard"
              value={displayName}
              sx={{ width: '100%', ml: 3 }}
              onChange={(e) => setDisplayName(e.target.value)}
            />
          </Box>
          <Box display='flex' flexDirection='row' justifyContent='flex-start' alignItems='center'>
            <Typography minWidth={120}>Email</Typography>
            <TextField
              label=""
              variant="standard"
              value={username}
              InputProps={{ readOnly: true }}
              sx={{ ml: 3, width: '100%' }}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Box>
        </Box>
      </CardContent>
      <CardActions sx={{ padding: '16px', display: 'flex', justifyContent: 'space-between', borderTop: '1px solid grey' }}>
        <Button
          className='white-outlined-button'
          sx={{ textTransform: 'none' }}
          onClick={() => navigate("/change-password")}
          disabled={isLoading}
        >
          Change Password
        </Button>
        <Button
          variant="contained"
          sx={{ textTransform: 'none' }}
          onClick={userUpdateHandle}
          disabled={isLoading}
        >
          Update
        </Button>
      </CardActions>
    </Card>
  )
}

export default Profile;
export { Profile };